// @ts-nocheck
function initFooterAccordion() {
  const footer = document.querySelector('footer[data-accordion-enabled="true"]');
  const isMobile = window.innerWidth < 900;

  if (!footer || !isMobile) return;

  const iconPlus = footer.dataset.iconPlus;
  const iconMinus = footer.dataset.iconMinus;

  const headers = footer.querySelectorAll('.accordion-header');
  headers.forEach((header) => {
    header.removeEventListener('click', header._accordionHandler);

    header._accordionHandler = function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);

      const icon = this.querySelector('.accordion-icon img');
      if (icon) {
        icon.src = expanded ? iconPlus : iconMinus;
      }

      const content = document.getElementById(this.getAttribute('aria-controls'));
      content.hidden = expanded;
      content.style.maxHeight = !expanded ? content.scrollHeight + 'px' : null;
    };

    header.addEventListener('click', header._accordionHandler);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initFooterAccordion();
});

document.addEventListener('shopify:section:load', function () {
  initFooterAccordion();
});

let _footerAccordionResizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(_footerAccordionResizeTimer);
  _footerAccordionResizeTimer = setTimeout(initFooterAccordion, 150);
});
